<template>
  <styled-tabs-container-wrap>
    <!--    <div v-if="!(tabsList || []).length" class="tabs-skeleton tabs-container">-->
    <!--      <div class="tabs-item"/>-->
    <!--      <div class="tabs-item_2"/>-->
    <!--    </div>-->

    <styledTabsContainer>
      <div v-if="tabsList" class="visible-tabs">
        <div
          v-for="(tab, index) in tabsList"
          :key="index"
          :class="{
            'visible-tab': true,
            'visible-tab--active': activeTab === tab.name,
          }"
          @click="_handleTabClick(tab.name, index)"
        >
          <template v-if="tab.callback === 'return'">
            <div class="return-icon">
              <tab-more />
            </div>
          </template>
          {{ $t(tab.name) }}
        </div>
      </div>
      <styled-underline :style="underlineStyle" />
    </styledTabsContainer>
  </styled-tabs-container-wrap>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { setTimeout } from 'timers';
import styled from 'vue-styled-components';
import TabMore from '@/components/svg/TabMore';

const styledUnderline = styled('div')`
  background-color: var(--primary);
  width: ${props => props.width};
  position: absolute;
  height: 2px;
  top: 28px;
  transform: translateX(${props => props.left}px);
  transition: all 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
`;
const styledTabsContainerWrap = styled.section`
  width: 100%;
  color: var(--secondary);
`;
const styledTabsContainer = styled('div')`
  border-bottom: 2px solid var(--border_color);
  width: 100%;
  .visible-tab {
    transition: all 0.25s ease;
    color: var(--on_background);
    &:hover {
      opacity: 1;
      color: var(--primary) !important;
      transition: all 0.25s ease;
    }
    &--active {
      color: var(--primary) !important;
      opacity: 1;
      transition: all 0.25s ease;
    }
  }
`;

export default {
  props: {
    tabsList: {
      type: Array,
    },
  },
  data() {
    return {
      activeTab: null,
      underlineStyle: {},
    };
  },
  watch: {
    tabsList(newVal) {
      setTimeout(() => {
        if (newVal[0].callback === 'return') {
          this.handleTabSelect(newVal[1].name, 1);
        } else {
          this.handleTabSelect(newVal[0].name, 0);
        }
      }, 4);
    },

    selectedCategory(newCategory) {
      let categoryIndex = this.categories.indexOf(newCategory);
      this.handleTabSelect(newCategory, categoryIndex !== -1 ? categoryIndex : 0);
    },
  },
  methods: {
    ...mapActions(['selectCategory', 'handleSearch']),
    getStyle(el) {
      return window.getComputedStyle ? getComputedStyle(el, '') : el.currentStyle;
    },
    _handleTabClick(name, index) {
      // Skip search
      this.handleSearch(null);
      this.handleTabSelect(name, index);
    },
    handleTabSelect(name, index) {
      this.activeTab = name;
      this.handleTabUnderline(index);
      const selectedTab = this.tabsList.find(t => {
        return t.name === name;
      });

      switch (selectedTab.callback) {
        case 'return':
          this.$router.push({
            name: 'PaymentMethodsListPage',
          });
          break;
        case 'breadcrumb':
          break;
        case 'category':
          this.selectCategory(name);
          break;
        default:
          this.$router.push({
            name: 'PaymentMethodsListPage',
          });
          break;
      }
    },

    handleTabUnderline(i) {
      const tabs = document.getElementsByClassName('visible-tab');
      if (tabs) {
        const style = this.getStyle(tabs[i]);
        let left = 0;

        const tabsArray = Array.prototype.slice.call(tabs);
        if (tabsArray.length > 0) {
          tabsArray.slice(0, i).forEach(tab => {
            left += tab.clientWidth + 15;
          });
        }

        if (this.isMobile && this.moreButtonEnabled && i === 2) {
          left =
            this.screenSize.width - style.width.match(/[+-]?\d+(?:\.\d+)?/g).map(Number)[0] - 40;
        }

        this.underlineStyle = {
          width: style.width,
          transform: `translateX(${left}px)`,
        };
      }
    },
  },
  computed: {
    ...mapState(['autoProcessData', 'selectedCategory', 'categories']),
  },
  components: {
    TabMore,
    styledUnderline,
    styledTabsContainer,
    styledTabsContainerWrap,
  },
};
</script>

<style lang="scss" scoped>
@keyframes shine-lines {
  0% {
    background-position: -100px;
  }
  40%,
  100% {
    background-position: 140px;
  }
}

.tabs-item,
.tabs-item_2 {
  width: 30%;
  border-radius: 0.4em;
  background-color: #d7d9dc;
  animation: shine-lines 2s infinite ease-out;
  margin-bottom: 10px;
  height: 18px;
  &_2 {
    width: 17%;
    margin-left: 1em;
    opacity: 0.6;
  }
}
</style>
